<template>
  <v-container fluid>
    <!-- <v-layout>
      <v-flex
        xs12
        lg8
      >
        <calcolatori />
      </v-flex>
      <v-flex
        xs-12
        lg4
      >
        <dilapay />
      </v-flex>
    </v-layout> -->
    <calcolatori />
  </v-container>
</template>

<script>
  import Calcolatori from './../components/dashboard/tools/Calcolatori'
  import Dilapay from './../components/dashboard/tools/Dilapay'

  export default {
    name: 'StrumentiContabilita',
    components: {
      Calcolatori,
      Dilapay
    }
  }
</script>

<style>
</style>
